import { ref, computed } from 'vue';
import { createGlobalState } from '@vueuse/core';
import { useDisposes } from '@/composables/use-disposes';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { CommentDialogService } from '../service/comment-dialog.service';
import type { BoxPosition, QuickComment } from '../type/comment-dialog.type';

export const useCommentDialog = createGlobalState(() => {
    const commentDialogService = injectService<CommentDialogService>(CommentDialogService);

    const { disposes } = useDisposes();

    const commentDialogState = ref(commentDialogService.state);
    disposes.push(commentDialogService.onStateChange(state => {
        commentDialogState.value = state;
    }));

    const isShowingCommentBox = computed(() => commentDialogState.value.isShowingCommentBox);

    const isShowingAddCommentBox = computed(() => commentDialogState.value.isShowingAddCommentBox);

    const isShowingEditQuickComment = computed(() => commentDialogState.value.isShowingEditQuickComment);

    const addCommentBoxPosition = computed(() => commentDialogState.value.addCommentBoxPosition);

    const quickCommentId = computed(() => commentDialogState.value.quickComment.predefined_comment_id);

    const quickCommentList = computed(() => {
        return (commentDialogState.value.quickComment.comment_texts || [])
            .map(item => item.comment_text);
    });

    function setIsShowingCommentBox(value: boolean) {
        commentDialogService.setIsShowingCommentBox(value);
    }

    function setIsShowingAddCommentBox(value: boolean | { display: boolean; position?: BoxPosition }) {
        commentDialogService.setIsShowingAddCommentBox(value);
    }

    function setIsShowingEditQuickComment(value: boolean) {
        commentDialogService.setIsShowingEditQuickComment(value);
    }

    function updateQuickComment(value: QuickComment) {
        commentDialogService.updateQuickComment(value);
    }

    return {
        isShowingCommentBox,
        isShowingAddCommentBox,
        isShowingEditQuickComment,
        addCommentBoxPosition,
        quickCommentId,
        quickCommentList,
        setIsShowingCommentBox,
        setIsShowingAddCommentBox,
        setIsShowingEditQuickComment,
        updateQuickComment,
    }
});
